export default "__VITE_ASSET__XB8AK$VN__"